import { Accordion, AccordionItem, Stack } from '@chakra-ui/react';
import { useState, type FC } from 'react';

import { AccordionContent } from '$/components/core/Collection/CollectionFilter/components/AdditionalFilter/components/AccordionContent';
import { AccordionHeader } from '$/components/core/Collection/CollectionFilter/components/AdditionalFilter/components/AccordionHeader';
import { ActiveFilterText } from '$/components/core/Collection/CollectionFilter/components/AdditionalFilter/components/ActiveFilterText';
import { FilterActions } from '$/components/core/Collection/CollectionFilter/components/FilterActions';
import { type FilterOptionGroup } from '$/services/usecases/filter';
import { type SingleMaterialFilterOption } from '$/services/usecases/materials';
import { getCollectionStore } from '$/stores/useCollectionStore';

interface Props {
  onMenuClose: VoidFunction;
  additionalFilter: FilterOptionGroup[];
  hideActions?: boolean;
  compactMode?: boolean;
}

export const AdditionalFilter: FC<Props> = ({
  onMenuClose,
  additionalFilter,
  hideActions = false,
  compactMode = false,
}) => {
  const [activeChanges, setActiveChanges] = useState(false);

  const filterTypes = additionalFilter.map((filter) => filter.searchField);

  const handleCheckboxToggle = (option: SingleMaterialFilterOption) => {
    setActiveChanges(true);
    getCollectionStore().toggleAppliedFilterOption(option);
  };

  return (
    <Stack pb={compactMode ? '0' : '5'}>
      <Accordion minW={compactMode ? '190px' : '23rem'} allowToggle>
        {additionalFilter.map((filter) => {
          return (
            <AccordionItem
              key={filter.searchField}
              border={compactMode ? 'none' : undefined}
              borderColor='border'
            >
              {({ isExpanded }) => (
                <>
                  <AccordionHeader
                    isExpanded={isExpanded}
                    label={filter.displayName}
                    compactMode={compactMode}
                  />
                  <AccordionContent
                    filter={filter}
                    onToggle={handleCheckboxToggle}
                    compactMode={compactMode}
                  />
                  <ActiveFilterText
                    isExpanded={isExpanded}
                    activeFilter={getCollectionStore().getActiveInCategory(
                      filter.searchField,
                    )}
                    compactMode={compactMode}
                  />
                </>
              )}
            </AccordionItem>
          );
        })}
      </Accordion>

      {!hideActions && (
        <FilterActions
          anyFilterActive={getCollectionStore().isAnyCategoryActive(
            filterTypes,
          )}
          activeChanges={activeChanges}
          onSubmit={() => onMenuClose()}
          onReset={() =>
            getCollectionStore().resetAppliedFilterOption(filterTypes)
          }
          px='4'
          py='5'
        />
      )}
    </Stack>
  );
};
